import { LinkSimpleHorizontalBreakIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FollowLink = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <LinkSimpleHorizontalBreakIcon size={Sizes[size]} {...rest} color={fill} />;
};

FollowLink.displayName = 'FollowLink';
